const assessmentTranslations = {
  short: {
    notProcessedReason: {
      label: "Warum nicht",
      values: {
        clientNotAvailable: "Mandantschaft nicht erreicht",
        clientNumberIncorrect: "Falsche Rufnummer",
        clientCancelled: "Mandantschaft hat Termin abgesagt",
        lawyerUnavailable: "Ich konnte nicht teilnehmen",
      },
    },
  },
};

export default assessmentTranslations;
